const removeEmpty = (value) => {
  if (value == null) return null
  if (typeof value === 'string') return value
  if (typeof value === 'number') return value
  if (Array.isArray(value)) {
    _res = [...value].map(v => removeEmpty(v)).filter(v => !!v)
    if (_res.length > 0) return _res
  }
  if (typeof value === 'object') {
    var _res = {}
    Object.keys(value).forEach(key => {
      const r = removeEmpty(value[key])
      if (r !== null) _res[key] = r
    })
    if (Object.keys(_res).length > 0) return _res
  }
  return null
}

const formatInfoBox = (infobox) => {
  let infoboxFormatted = {
    type: infobox.type,
    content: {}, 
  }
  if (infobox.type === 'drug') {
    const getDefNum = (defId) => {
      // defId: index of defendant from backend
      // eg. [2009] hkdc 1519&D1
      return defId.split('&D')[1] || null // TODO: error handling
    }
    
    const getChargeNum = (chargeId) => {
      // chargeId: index of charge from backend
      // eg. [2009] hkdc 1519&C1
      return chargeId.split('&C')[1] || null // TODO: error handling
    }

    const formatDrug = (dc) => {
      const { commission_age, sentencing_age, ...bg } = dc.d.background
      let background = []
      if (bg.nationality && bg.nationality.replace('_', ' ').toLowerCase() !== 'hong kong') background.push(bg.nationality)
      if (bg.extreme_youth) background.push('extreme_youth')
      if (bg.previous_criminal_record) background.push('previous_criminal_records')
      if (bg.clear_record) background.push('clear_record')

      let penalty = []
      if (dc.d.penalty.training_centre) {penalty.push('training_centre')}
      if (dc.d.penalty.detention_centre) {penalty.push('detention_centre')}
      if (dc.d.penalty.addiction_treatment_centre) {penalty.push('addiction_treatment_centre')}
      if (dc.d.penalty.other_penalty) {penalty.push(dc.d.penalty.other_penalty.replace(/\s/gm, "_").toLowerCase())}
     
      const defendant = {
        commission_age: commission_age,
        sentencing_age: sentencing_age,
        background: background,
        penalty: penalty,
      }
      
      const defendant_charges = {}
      Object.keys(dc.cs).forEach(chargeNum => {  
        const c = dc.cs[chargeNum]  // c stands for charge
        var drugs = {}
        c.drugs.forEach(drug => {
          if (drugs[drug.drug_type] == null) {
            drugs[drug.drug_type] = 0
          }
          drugs[drug.drug_type] += drug.drug_quantity
        })
        
        //format drug quantity floating point
        for (const key in drugs) {
          drugs[key] = drugs[key].toFixed(2)
        }
        
        const mitigate = {
          remorse: c.mitigate.remorse ? c.mitigate.remorse_sentence : null,
          self_consume: c.mitigate.self_consume ? c.mitigate.self_consume_sentence : null,
          controlled_delivery: c.mitigate.controlled_delivery ? c.mitigate.controlled_delivery_sentence : null,
          testimony: c.mitigate.testimony ? c.mitigate.testimony_sentence : null,
          good_character: c.mitigate.good_character ? c.mitigate.good_character_sentence : null,
          mitigating_others: c.mitigate.mitigating_others ? c.mitigate.mitigating_others_sentence : null,
          //mitigating_total_without_plea: c.mitigate.mitigating_total_without_plea,
         //mitigating_total_with_plea: c.mitigate.mitigating_total_with_plea,
        }
    
        const aggravate = {
          refugee: c.aggravate.refugee ? c.aggravate.refugee_sentence || '' : null,
          bail: c.aggravate.bail ? c.aggravate.bail_sentence || ''  : null,
          street: c.aggravate.street ? c.aggravate.street_sentence || ''  : null,
          persistent: c.aggravate.persistent ? c.aggravate.persistent_sentence || ''  : null,
          international: c.aggravate.international ? c.aggravate.international_sentence || ''  : null,
          aggravating_others: c.aggravate.aggravating_others ? c.aggravate.aggravating_others_sentence || ''  : null,
        }
    
        var guilty_plea
        if (c.guilty_plea.plead_guilty === "0") {
          guilty_plea = ['plea_not_guilty']
        } else {  // c.guilty_plea.plead_guilty === "1"
          guilty_plea = {
            guilty_plea_stage: c.guilty_plea.guilty_plea_stage,
          }
          if (c.guilty_plea.guilty_plea_sentence) {
            const numSentence = Number(c.guilty_plea.guilty_plea_sentence)
            if (isNaN(numSentence)) {
              guilty_plea.guilty_plea_sentence_str = c.guilty_plea.guilty_plea_sentence
            } else if (numSentence >= 1) { // assume the number referes to number of months
              guilty_plea.guilty_plea_sentence_month = numSentence
            } else {
              guilty_plea.guilty_plea_sentence_percent = Math.round(numSentence * 100)
            }
          }
        }

        const starting_point = c.sentence.starting_point_agv_mtg || c.sentence.starting_point_agv || c.sentence.starting_point_mtg || c.sentence.starting_point
    
        // if defendant_charges[chargeNum] contains no info other then charge_name, then ignore the charge, as it is probably not related to dt.
        const defendant_charges_num = removeEmpty({
          ordinances: c.ordinances,
          drugs: drugs,
          mitigate: mitigate,
          aggravate: aggravate,
          guilty_plea: guilty_plea,
          starting_point: starting_point,
          sentence: c.sentence.single_charge_penalty,
        })
        if (defendant_charges_num != null) {
          defendant_charges[chargeNum] = {
            charge_name: [c.charge_name],
            ...defendant_charges_num,
          }
        }
      })
    
      return {
        index: dc.index,
        defendant: defendant,
        defendant_charges: defendant_charges
      }
    }

    Object.keys(infobox.defendants).forEach((defId) => {
      const {charges, ..._defInfo} =  infobox.defendants[defId]
      const defNum = getDefNum(defId)
      let dc = {
        d: _defInfo,
        cs: {},
      }
      Object.keys(charges).forEach(chargeId => {
        const chargeNum = getChargeNum(chargeId)
        dc.cs[chargeNum] = {
          ...charges[chargeId],
          ...infobox.charges[chargeId],
        }
      })
      infoboxFormatted.content[defNum] = formatDrug(dc)
    })

    //filter out charges that are not trafficking related, need to refine
    Object.keys(infoboxFormatted.content).forEach(def =>{
      for (var charge in infoboxFormatted.content[def].defendant_charges){
        if(!infoboxFormatted.content[def].defendant_charges[charge].charge_name[0].match(/traffic/gi)){
          delete infoboxFormatted.content[def].defendant_charges[charge]
        }
      }
      
    })
   
  }

  if (infobox.type === 'pi') {
    const {type, ...content} = infobox
    const {psla_amount, treatment_type_received, injury_type, sickleave_actual, occupation_aft_actual, ...bg} = content.background
    
    let loss = []
    Object.keys(content.loss).forEach(key => {
      if (content.loss[key] != null) loss.push(key)
    })

    let comparable_cases = {}
    Object.keys(content.comparable_cases).forEach(level => {
      if (content.comparable_cases[level].length === 0) return
      const _level = level === 'null' ? 'level_unspecified' : level  // patching. May be better to do this in backend
      comparable_cases[_level] = content.comparable_cases[level].map(linkObj => {
        return {
          text: linkObj.neutral_citation || linkObj.action_number || linkObj.case_name || (linkObj.url ? 'Case' : null),
          url: linkObj.url,
        }
      })
    })

    infoboxFormatted.content = {
      background: bg,
      injury_type: injury_type,
      injuries: content.injuries,
      treatment_type_received: treatment_type_received ? treatment_type_received.split('\n') : null,
      loss: loss,
      comparable_cases: comparable_cases,
      psla_amount: psla_amount,
    }
  }

  return removeEmpty(infoboxFormatted)
}

export default {
  formatInfoBox
}